
import { LocalStorageCache, GlobalCacheKeys } from "./../Helpers/LocalStorageCache";

export class Impersonation {
    public init() {
        LocalStorageCache.getInstance().deletebyGlobalCacheKey(GlobalCacheKeys.User);

    }
    
}